import React from 'react';

const HilfeRingSonderfall = () => {
    return(
      <div>
        <p>Vögel müssen für gewöhnlich einen geschlossenen Ring tragen. 
           Sollten Ihr Tier anstelle eines Ringes einen Transponder haben, wählen Sie bitte 
           diesen als Art der Kennzeichnung aus.
        </p>
        <p>
           Ansonsten begründen Sie hier bitte, warum ein anderer Ringtyp oder kein 
           Ring angelegt ist.
           Gegebenenfalls legen Sie bei den Dokumenten die Aunahmegenehmigung bei.
        </p>
      </div>
    )
}

export default HilfeRingSonderfall;
